import {useTranslation} from "react-i18next"

import {PaymentOption} from "./PaymentOption"

import {usePaymentArrangementInitiateSetup} from "@indebted/payment-arrangement/usePaymentArrangementInitiateSetup"

function PaymentArrangementOptionLink() {
	const initiateSetupMutation = usePaymentArrangementInitiateSetup()
	const {t} = useTranslation()

	return (
		<PaymentOption
			Type="PaymentArrangement"
			onClick={() => !initiateSetupMutation.isPending && initiateSetupMutation.mutate()}
			Title={t("customer_get.outstanding_balance.paymentplan.create_payment_plan")}
			Description={t("customer_get.outstanding_balance.paymentplan.split_up_payments")}
		/>
	)
}

export {PaymentArrangementOptionLink}
